import CryptoJS from "crypto-js";

/**
 * 파일로부터 SHA-256 해시 값을 비동기적으로 계산
 * @param {File} file - 해시 값을 계산할 파일 객체
 * @returns {Promise<string>} 계산된 해시 값 (16진수 문자열)
 */
export async function sha256HashFile(file) {
    const buffer = await file.arrayBuffer(); // ArrayBuffer 읽기
    const wordArray = CryptoJS.lib.WordArray.create(buffer); // WordArray 변환
    const hashHex = CryptoJS.SHA256(wordArray).toString(); // hex 문자열;

    return hashHex;
}
export async function sha256HashFileChunk(file) {
    const CHUNK_SIZE = 2 * 1024 * 1024; // 2MB
    const hash = CryptoJS.algo.SHA256.create();

    let offset = 0;

    while (offset < file.size) {
        const chunk = file.slice(offset, offset + CHUNK_SIZE);
        const buffer = await chunk.arrayBuffer();

        const wordArray = CryptoJS.lib.WordArray.create(buffer);
        hash.update(wordArray);

        offset += CHUNK_SIZE;
    }

    return hash.finalize().toString(CryptoJS.enc.Hex);
}

export function sha256HashString(str) {
    return CryptoJS.SHA256(str).toString(CryptoJS.enc.Hex);
}

export function generateRandomString(length = 16) {
    return CryptoJS.lib.WordArray.random(length).toString();
}
